import { simpleSet } from '@r/reducers/utils';

const setCalculationModeUnits = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.units;

export const units = setCalculationModeUnits(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_UNITS',
  'inch'
);
